import { motion } from "framer-motion";
import { DIFFERENTIATORS } from "@/data/content";
import { MaskLines, Reveal } from "@/components/site/Reveal";

export const WhyUs = () => (
  <section data-testid="why-section" className="bg-[#FAFCFF] py-24 sm:py-32">
    <div className="container-x grid gap-14 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <p className="eyebrow text-[#1777AF]">Why Bodhatek</p>
          <MaskLines lines={["Service first.", "Quality always.", { text: "Peace of mind.", className: "text-grad" }]} className="mt-5 font-display text-4xl font-bold leading-[1.02] tracking-tight text-slate-900 sm:text-5xl" />
          <Reveal delay={0.2}>
            <div className="clip-notch relative mt-10 aspect-[4/3] overflow-hidden rounded-2xl">
              <img src="/images/field.webp" alt="Bodhatek field technician installing network equipment" loading="lazy" className="h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-tr from-[#1777AF]/30 to-transparent mix-blend-multiply" />
            </div>
          </Reveal>
        </div>
      </div>
      <div className="lg:col-span-7">
        {DIFFERENTIATORS.map((d, i) => (
          <motion.div
            key={d.n}
            data-testid={`differentiator-${d.n}`}
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: i * 0.06, ease: [0.22, 1, 0.36, 1] }}
            className="group relative grid grid-cols-[auto_1fr] gap-6 border-t border-slate-200 py-10 sm:gap-10 sm:py-12"
          >
            <span className="absolute left-0 top-0 h-px w-0 bg-gradient-to-r from-[#1777AF] to-[#29C1D3] transition-[width] duration-700 group-hover:w-full" />
            <span className="font-mono text-sm text-[#1777AF]">{d.n}</span>
            <div>
              <h3 className="font-display text-2xl font-semibold tracking-tight text-slate-900 transition-transform duration-500 group-hover:translate-x-2 sm:text-3xl">{d.title}</h3>
              <p className="mt-3 max-w-lg leading-relaxed text-slate-600">{d.text}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
